import Cookie from "js-cookie";

import GlobalState from "../../../../../shared/utilities/globalState";
import { itemIsSaved } from "../../analytics/ga";
import executeSave from "../../helpers/executeSave";
import getCurrentUser from "../../helpers/getCurrentUser";

class App {
  initialize = className => {
    [...document.getElementsByClassName(className)].forEach(el => {
      el.addEventListener("click", this.handleClick);
    });
  };

  isUserLoggedIn = async callback => {
    const viewerInfo = await getCurrentUser();

    if (viewerInfo) {
      callback(true);
    } else {
      callback(false);
    }
  };

  handleClick = e => {
    const itemId = e.target.getAttribute("data-item-id");
    const itemType = e.target.getAttribute("data-item-type");

    GlobalState.set("itemData", { itemId, itemType });

    this.isUserLoggedIn(loggedIn => {
      if (loggedIn) {
        this.handleSave();
      } else {
        Cookie.set("save", {
          item_id: itemId,
          item_type: itemType
        });
        const triggerScenario = GlobalState.get("triggerScenario");

        if (typeof triggerScenario === "function") {
          GlobalState.get("callbacks").accountCreated = undefined;
          GlobalState.get("callbacks").login = undefined;

          GlobalState.registerCallback("accountCreated", this.handleSave);
          GlobalState.registerCallback("login", this.handleSave);
          GlobalState.set("handleSaveAfterGoogleOneTapLogin", this.handleSave);

          triggerScenario("EmailCapture", {
            item_id: itemId,
            item_type: itemType
          });
        }
      }
    });
  };

  handleSave = () => {
    if (!GlobalState.get("itemData")) {
      return null;
    }

    const { itemId, itemType } = GlobalState.get("itemData");

    return executeSave(itemId, itemType).then(() => {
      itemIsSaved(itemType.toLowerCase(), itemId);
      window.location.reload();
    });
  };
}

export default App;
